<ion-content class="login-content">
  <div class="login-wrapper">

    <!-- Brand / Hero Area -->
    <div class="login-hero">
      <div class="brand-logo-wrap">
        <img class="brand-logo" src="assets/icon/LogoHomeLoginPage.svg" alt="CF Agent Builder">
      </div>
      <div class="brand-tagline">
        <ion-icon name="shield-checkmark-outline"></ion-icon>
        <ion-text>Secure Agent Portal</ion-text>
      </div>
    </div>

    <!-- Main Card -->
    <div class="login-card">

      <button type="button" class="modal-close-btn" (click)="closeModal()" aria-label="Close">
        <ion-icon name="close-outline"></ion-icon>
      </button>

      @if (!isOTPSend) {
      <!-- Step 1: Mobile Number -->
      <div class="step-header">
        <div class="step-icon-box">
          <ion-icon name="phone-portrait-outline"></ion-icon>
        </div>
        <div class="step-copy">
          <ion-text class="step-kicker">
            <ion-icon name="log-in-outline"></ion-icon>
            Sign In
          </ion-text>
          <h2 class="step-title">Enter your mobile number</h2>
          <p class="step-subtitle">We'll send a one-time verification code to confirm your identity.</p>
        </div>
      </div>

      <form name="mobileForm" [formGroup]="mobileForm" class="login-form">

        <div class="field-block">
          <label class="field-label">
            <ion-icon name="call-outline"></ion-icon>
            Phone Number
          </label>
          <mat-form-field class="login-field" appearance="outline">
            <span matTextPrefix class="phone-prefix">
              <ion-icon name="flag-outline"></ion-icon>
              +91&nbsp;
            </span>
            <input type="text" matInput placeholder="10-digit mobile number" maxlength="10"
              [(ngModel)]="mobileform.MobileNo" formControlName="MobileNo">
            @if (mobileForm.get('MobileNo').hasError('required')) {
              <mat-error>Mobile number is required</mat-error>
            }
            @if (mobileForm.get('MobileNo').hasError('minlength') || mobileForm.get('MobileNo').hasError('pattern')) {
              <mat-error>Enter a valid 10-digit mobile number</mat-error>
            }
          </mat-form-field>
        </div>

        @if (isAgentUserLoginValue) {
        <div class="field-block">
          <label class="field-label">
            <ion-icon name="briefcase-outline"></ion-icon>
            Agent Code
          </label>
          <mat-form-field class="login-field" appearance="outline">
            <input type="text" matInput maxlength="6" placeholder="Enter 6-digit agent code"
              [(ngModel)]="mobileform.AgentCode" formControlName="AgentCode">
            @if (mobileForm.get('AgentCode').hasError('required')) {
              <mat-error>Agent code is required</mat-error>
            }
            @if (mobileForm.get('AgentCode').hasError('minlength') || mobileForm.get('AgentCode').hasError('maxlength')) {
              <mat-error>Enter a valid 6-digit agent code</mat-error>
            }
          </mat-form-field>
        </div>
        }

        @if (!isAgentUserLoginValue) {
        <button type="button" class="agent-switch-btn" (click)="isAgentUserLogin()">
          <ion-icon name="briefcase-outline"></ion-icon>
          <span>Are you an Agent User? Login here</span>
          <ion-icon name="chevron-forward-outline" class="switch-chevron"></ion-icon>
        </button>
        }

        <div class="form-footer">
          @if (!isAgentUserLoginValue) {
          <div class="signup-nudge">
            <ion-icon name="person-add-outline"></ion-icon>
            <span>New here?</span>
            <button type="button" class="text-link-btn" (click)="signUp()">
              Create account
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </button>
          </div>
          } @else {
          <button type="button" class="outline-action-btn" (click)="backToAgentLogin()">
            <ion-icon name="arrow-back-outline"></ion-icon>
            Back to Login
          </button>
          }

          <button type="button" class="primary-action-btn" [disabled]="mobileForm.invalid" (click)="sendMobileOTP()">
            <ion-icon name="send-outline"></ion-icon>
            Send OTP
          </button>
        </div>

      </form>
      }

      @if (isOTPSend) {
      <!-- Step 2: OTP Verification -->
      <div class="step-header">
        <div class="step-icon-box otp-step">
          <ion-icon name="lock-closed-outline"></ion-icon>
        </div>
        <div class="step-copy">
          <ion-text class="step-kicker">
            <ion-icon name="shield-checkmark-outline"></ion-icon>
            Verification
          </ion-text>
          <h2 class="step-title">Verify your identity</h2>
          <p class="step-subtitle">
            <ion-icon name="phone-portrait-outline"></ion-icon>
            OTP sent to&nbsp;<strong>+91 {{ mobileform.MobileNo }}</strong>
          </p>
        </div>
      </div>

      <div class="otp-body">
        <div class="otp-input-row">
          <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
        </div>

        @if (invalidOTP) {
        <div class="otp-error-msg">
          <ion-icon name="close-circle-outline"></ion-icon>
          Invalid OTP. Please check and try again.
        </div>
        }

        <div class="otp-resend-row">
          <ion-icon name="time-outline"></ion-icon>
          <span>Didn't receive the code?</span>
          @if (isCounter) {
            <button type="button" class="text-link-btn" (click)="reSendOTP()">
              <ion-icon name="refresh-outline"></ion-icon>
              Resend OTP
            </button>
          }
          @if (!isCounter) {
            <countdown class="otp-timer" #countdown [config]="configTimer"
              (event)="handleEvent($event)"></countdown>
          }
        </div>

        <div class="form-footer">
          <button type="button" class="outline-action-btn" (click)="back()">
            <ion-icon name="arrow-back-outline"></ion-icon>
            Back
          </button>
          <button type="button" class="primary-action-btn" [disabled]="!isvalid" (click)="submitOTP()">
            <ion-icon name="checkmark-circle-outline"></ion-icon>
            Verify &amp; Login
          </button>
        </div>
      </div>
      }

    </div>

    <!-- Security footer -->
    <div class="login-security-note">
      <ion-icon name="lock-closed-outline"></ion-icon>
      <ion-text>End-to-end encrypted &amp; secure</ion-text>
    </div>

  </div>
</ion-content>